import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { SiteNav } from "../features/navigation";
import { PageShell } from "../platform/ui/PageShell";
import { routes } from "./routes";

/** Shown if a page throws while rendering, so a fault never leaves a blank screen. */
export function RouteErrorPage() {
  const error = useRouteError();
  const missing = isRouteErrorResponse(error) && error.status === 404;
  console.error("A page failed to render.", error);
  return (
    <>
      <SiteNav />
      <PageShell
        title={missing ? "Page not found" : "Something went wrong"}
        lead={
          missing ? "There is nothing at this address." : "This page hit a fault while loading."
        }
      >
        <p>
          <Link to={routes.home()}>Back to Orla</Link>
        </p>
      </PageShell>
    </>
  );
}
